const tools = [
  // {
  //   tabName: "Notice",
  //   page: [
  //     {
  //       name: "Terminal",
  //       path: "/tools/notice/terminal",
  //       authority: "PORTAL",
  //       rolePermission: "TOOLS_NOTICE",
  //     },
  //     {
  //       name: "Web",
  //       path: "/tools/notice/web",
  //       authority: "PORTAL",
  //       rolePermission: "TOOLS_NOTICE",
  //     },
  //   ],
  // },
  // {
  //   tabName: "Email",
  //   page: [
  //     {
  //       name: "Mass Email",
  //       path: "/tools/email/mass-email",
  //       authority: "PORTAL",
  //       rolePermission: "TOOLS_EMAIL",
  //     },
  //     {
  //       name: "Offline Email Template",
  //       path: "/tools/email/offline-email-template",
  //       authority: "PORTAL",
  //       rolePermission: "TOOLS_EMAIL",
  //     },
  //     {
  //       name: "Online Email Template",
  //       path: "/tools/email/online-email-template",
  //       authority: "PORTAL",
  //       rolePermission: "TOOLS_EMAIL",
  //     },
  //   ],
  // },
  // {
  //   tabName: "Merchant Report Email",
  //   page: [],
  //   path: "/tools/merchant-report-email",
  //   authority: "PORTAL",
  //   rolePermission: "TOOLS_MERCHANT_REPORT_EMAIL",
  // },
  {
    tabName: "Offline Statement PDF",
    page: [],
    path: "/tools/offline-statement-pdf",
    authority: "PORTAL",
    rolePermission: "TOOLS_OFFLINE_STATEMENT_PDF",
  },
  // {
  //   tabName: "Online Statement PDF",
  //   page: [],
  //   path: "/tools/online-statement-pdf",
  //   authority: "PORTAL",
  //   rolePermission: "TOOLS_ONLINE_STATEMENT_PDF",
  // },
  // {
  //   tabName: "MDR Calculator",
  //   page: [],
  //   path: "/tools/mdr-calculator",
  //   authority: "PORTAL",
  //   rolePermission: "TOOLS_MDR_CALCULATOR",
  // },
  // {
  //   tabName: "Card Split",
  //   page: [],
  //   path: "/tools/card-split",
  //   authority: "PORTAL",
  //   rolePermission: "TOOLS_CARD_SPLIT",
  // },
  // {
  //   tabName: "Thermal Paper Requests",
  //   page: [],
  //   path: "/tools/paperRoll/paperRollRequestList/paperRollRequestList",
  //   authority: "PORTAL",
  //   rolePermission: "TOOLS_THERMAL_PAPER_REQUESTS",
  // },
  // {
  //   tabName: "Paper Request",
  //   page: [],
  //   path: "/tools/paperRoll/paperRollRequestCreate/paperRollRequestCreate",
  //   authority: "PORTAL",
  //   rolePermission: "TOOLS_THERMAL_PAPER_REQUESTS",
  //   showInSidebar: false,
  // },
];

export default tools;
